<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="container" style="margin-top:88px">
      <p>&zwnj;</p>

      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Home">
              <span class="text-primary">
                Home
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item active" aria-current="page">Videos</li>
        </ol>
      </nav>
      <p>&zwnj;</p>

      <div v-if="hasOfficalVideo">
        <span class="title_fontStyle my-5 h2"> <i class="fas fa-caret-right"></i> Official Videos </span>

        <p>&zwnj;</p>
        <p>&zwnj;</p>

        <div class="row">
          <div class="col-lg-4 mb-4" v-for="item in OfficalVideosList">
            <a
              :href="`https://www.youtube.com/embed/${item.VideoUrl}`"
              frameborder="0"
              allow="autoplay; encrypted-media"
              data-fancybox
              data-width="1280"
              data-height="720"
            >
              <img
                :src="`https://img.youtube.com/vi/${item.VideoUrl}/hqdefault.jpg`"
                class="BannerHover "
                width="100%"
                alt=""
                @click="saveLog(item.VideoNo)"
              />
            </a>

            <div class="my-3 text-center">
              <div style="height:50px; font-size:17px;font-weight:bold">{{ item.VideoName }}</div>
            </div>
          </div>
        </div>

        <hr />
        <p>&zwnj;</p>
      </div>

      <span class="title_fontStyle my-5 h2"> <i class="fas fa-caret-right"></i> Exhibitor Videos </span>

      <p>&zwnj;</p>
      <p>&zwnj;</p>

      <div class="row">
        <div class="col-lg-4 mb-4" v-for="item in VideosList">
          <div v-if="item.videoLink">
            <a
              :href="`https://www.youtube.com/embed/${item.videoLink}`"
              frameborder="0"
              allow="autoplay; encrypted-media"
              data-fancybox
              data-width="1280"
              data-height="720"
            >
              <img
                :src="`https://img.youtube.com/vi/${item.videoLink}/hqdefault.jpg`"
                class="BannerHover "
                width="100%"
                alt=""
                @click="saveLog(item.VideoID)"
              />
            </a>
          </div>

          <div v-if="item.videoLink_Youku" class=" BannerHover" style="background-color:#000000">
            <div>
              <a
                :href="`https://player.youku.com/embed/${item.videoLink_Youku}==?rel=0&amp;autoplay=1`"
                data-fancybox
                data-type="iframe"
                data-width="1280"
                data-height="720"
                style="color:#434242"
              >
                <div class="topUK BannerHover">
                  <iframe
                    :src="`https://player.youku.com/embed/${item.videoLink_Youku}`"
                    frameborder="0"
                    width="349px"
                    height="254px"
                  >
                  </iframe>

                  <div class="UKframe"></div>
                </div>
              </a>
            </div>
          </div>

          <div class="ProNameFrame text-center mt-3">
            <div style=" font-size:17px font-weight:bold">
              <div class="ellipsis_pro">
                {{ item.VideoTopic }}
              </div>
            </div>

            <div class="mb-2 pointer" style="height:30px " @click.prevent="goExhDetail(item.RegNo)">
              <p class="text-muted ellipsis_exh" style="font-size:13px">{{ item.ComName }}</p>
            </div>
          </div>
        </div>
      </div>
      <p>&zwnj;</p>
      <p>&zwnj;</p>

      <div class="PcDevice">
        <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center">
          <nav>
            <ul class="pagination pointer">
              <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                <span class="page-link" title="Last ten pages" aria-label="Previous" @click="returntenPage()">
                  <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                </span>
              </li>
              <li class="page-item" :class="{ disabled: currentPage == 1 }">
                <span class="page-link" title="Last page" aria-label="Previous" @click="lastPage()">
                  <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                </span>
              </li>
              <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                <span class="page-link" @click="getPage(page)">{{ page }}</span>
              </li>

              <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                <span class="page-link" title="Next page" aria-label="Next" @click="nextPage()">
                  <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                </span>
              </li>
              <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == totaltenPageNum - 1 }">
                <span class="page-link" title="Next ten pages" aria-label="Next" @click="nexttenPage()">
                  <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                </span>
              </li>
            </ul>
            <p class="text-center mt-2">{{ currentPage }} of {{ totalPage }}</p>
            <p>&zwnj;</p>
          </nav>
        </div>
      </div>

      <div class="MbDevice">
        <div v-if="totalPage > 1" class="pt-3 d-flex justify-content-center">
          <nav>
            <ul class="pagination pagination-sm pointer">
              <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == 0 }">
                <span class="page-link" title="Last ten pages" aria-label="Previous" @click="returntenPage()">
                  <span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
                </span>
              </li>
              <li class="page-item" :class="{ disabled: currentPage == 1 }">
                <span class="page-link" title="Last page" aria-label="Previous" @click="lastPage()">
                  <span aria-hidden="true"> <i class="fas fa-angle-left"></i> </span>
                </span>
              </li>
              <li class="page-item" v-for="page in showpage" :key="page" :class="{ active: currentPage == page }">
                <span class="page-link" @click="getPage(page)">{{ page }}</span>
              </li>

              <li class="page-item" :class="{ disabled: currentPage == totalPage }">
                <span class="page-link" title="Next page" aria-label="Next" @click="nextPage()">
                  <span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
                </span>
              </li>
              <li v-if="totaltenPageNum > 1" class="page-item" :class="{ disabled: tenPageNum == totaltenPageNum - 1 }">
                <span class="page-link" title="Next ten pages" aria-label="Next" @click="nexttenPage()">
                  <span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
                </span>
              </li>
            </ul>
            <p class="text-center mt-2">{{ currentPage }} of {{ totalPage }}</p>
            <p>&zwnj;</p>
          </nav>
        </div>
      </div>

      <p>&zwnj;</p>
      <p>&zwnj;</p>
    </div>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LobbyNavbar,
    },

    data() {
      return {
        VideosList: [],
        OfficalVideosList: [],

        currentPage: 2,
        totalPage: '',
        totalNo: '',
        ProductRawData: [],
        totaltenPageNum: 0,
        tenPageNum: 0,
        showpage: [],
        token: '',
        hasOfficalVideo: false,
      }
    },

    computed: {
      ...mapGetters(['ListStatus', 'Roomvisible', 'ShowRoom', 'exhcode']),
    },

    methods: {
      setIndex(index) {
        this.index = index
      },

      goExhDetail(id) {
        window.open(`https://www.chanchao.com.tw/touchtaiwan/onlineexpo/ExhibitorDetail/${id}`)
      },

      //瀏覽紀錄

      saveLog(videoID) {
        const vm = this

        vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
          let CSRFToken = response.data

          let NowPageUrl = location.href

          const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
          const info = {
            Type: 'VID',
            ID: videoID,
            Url: NowPageUrl,
            CSRF: CSRFToken,
          }

          vm.$http.post(url, info).then(function(response) {
            if (response.data == '200') {
              console.log('Log success')
            } else if (response.data == '251') {
              console.log('Log fail')
            }
          })
        })
      },

      //分頁

      getPage(page) {
        const vm = this
        document.location.href = `https://www.chanchao.com.tw/touchtaiwan/onlineexpo/Videos/Page=${page}`
      },

      nextPage() {
        const vm = this
        let nextP = Number(vm.currentPage) + 1

        document.location.href = `https://www.chanchao.com.tw/touchtaiwan/onlineexpo/Videos/Page=${nextP}`
      },

      lastPage() {
        const vm = this
        let lastP = Number(vm.currentPage) - 1

        document.location.href = `https://www.chanchao.com.tw/touchtaiwan/onlineexpo/Videos/Page=${lastP}`
      },

      nexttenPage() {
        const vm = this
        vm.tenPageNum = vm.tenPageNum + 1
        vm.showpage = vm.ProductRawData[vm.tenPageNum]
        vm.currentPage = vm.showpage[0]

        document.location.href = `https://www.chanchao.com.tw/touchtaiwan/onlineexpo/Videos/Page=${vm.currentPage}`
      },

      returntenPage() {
        const vm = this
        vm.tenPageNum = vm.tenPageNum - 1
        vm.showpage = vm.ProductRawData[vm.tenPageNum]
        vm.currentPage = vm.showpage[0]

        document.location.href = `https://www.chanchao.com.tw/touchtaiwan/onlineexpo/Videos/Page=${vm.currentPage}`
      },
    },

    created() {
      $('.modal').modal('hide')

      const vm = this
      this.$store.dispatch('ShowChatRoom', false)

      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)

      vm.currentPage = vm.$route.params.VideoPage

      // if (!vm.currentPage) {
      //   vm.currentPage = 1
      // }

      vm.token = vm.$cookies.get('as')

      vm.$store.dispatch('updateLoading', true)

      //大會影音列表
      vm.$http
        .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/historyVideos/${vm.exhcode}?Page=1&Lang=en`)
        .then((response) => {
          vm.OfficalVideosList = response.data
          if (vm.OfficalVideosList.length > 0) {
            vm.hasOfficalVideo = true
            vm.$store.dispatch('updateLoading', false)
          } else {
            vm.hasOfficalVideo = false
            vm.$store.dispatch('updateLoading', false)
          }

          vm.$http
            .get(
              `https://www.chanchao.com.tw/apiOnlineExpo/v1/Videos/${vm.exhcode}?Regno=&Page=${vm.currentPage}&Lang=en`
            )
            .then((response) => {
              vm.totalNo = response.data.DataTotal

              if (response.data.PageTotal > 0) {
                vm.VideosList = response.data.Videos
                vm.totalPage = response.data.PageTotal

                for (let i = 0; i < vm.totalPage; i++) {
                  if (i % 10 === 0) {
                    vm.ProductRawData.push([])
                  }

                  const page = parseInt(i / 10)
                  vm.ProductRawData[page].push(i + 1)
                }

                vm.totaltenPageNum = vm.ProductRawData.length

                let anaNowPage = vm.currentPage - 1

                vm.tenPageNum = parseInt(anaNowPage / 10)
                vm.showpage = vm.ProductRawData[vm.tenPageNum]
              }
            })
        })

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        let CSRFToken = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: CSRFToken,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      })
    },
  }
</script>

<style lang="scss" scoped>
  .ellipsis_pro {
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }

  .ellipsis_exh {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }

  .topUK {
    position: relative;
  }

  .UKframe {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
